// ============================================================
// adminPage.js — Lógica de las páginas de administración
// ============================================================
import { qs, on } from './utils.js';
import { toast } from './toast.js';
import { apiRequest } from './api.js';

export function initAdminPage() {
  const page = document.body.dataset.page;
  
  if (page === 'admin-newsletter') {
    initNewsletterAdmin();
  } else if (page === 'admin-suscripciones') {
    initSuscripcionesAdmin();
  }
}

// ── ADMINISTRACIÓN DE NEWSLETTER ──────────────────────────────
async function initNewsletterAdmin() {
  console.log('[Admin] Inicializando panel de Newsletter...');

  let allSubscribers = [];

  const tableBody = qs('#subscribersTableBody');
  const searchInput = qs('#adminSearchInput');
  const countDisplay = qs('#subscribersCount');
  const countNewDisplay = qs('#newSubscribersCount');

  // Cargar datos
  async function loadSubscribers() {
    try {
      if (tableBody) tableBody.innerHTML = '<tr><td colspan="3" style="padding: 24px; text-align: center; color: #8e90a6;">Cargando suscriptores...</td></tr>';
      
      const subscribers = await apiRequest('/newsletter/subscribers');
      allSubscribers = subscribers || [];
      
      renderStats();
      renderTable(allSubscribers);
    } catch (err) {
      console.error('[Admin] Error cargando suscriptores:', err);
      toast({ message: err.message || 'Error al cargar los suscriptores de la newsletter.', type: 'error' });
      if (tableBody) {
        tableBody.innerHTML = '<tr><td colspan="3" style="padding: 24px; text-align: center; color: #ff5b5b;">No se pudieron cargar los datos de la newsletter.</td></tr>';
      }
    }
  }

  // Estadísticas
  function renderStats() {
    if (countDisplay) countDisplay.textContent = allSubscribers.length;
    
    if (countNewDisplay) {
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      
      const newSubs = allSubscribers.filter(sub => {
        const createdDate = new Date(sub.createdAt);
        return createdDate >= sevenDaysAgo;
      });
      
      countNewDisplay.textContent = newSubs.length;
    }
  }

  // Renderizar tabla
  function renderTable(list) {
    if (!tableBody) return;

    if (list.length === 0) {
      tableBody.innerHTML = '<tr><td colspan="3" style="padding: 24px; text-align: center; color: #8e90a6;">No se encontraron suscriptores.</td></tr>';
      return;
    }

    tableBody.innerHTML = list.map(sub => {
      const date = new Date(sub.createdAt).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });

      return `
        <tr style="border-bottom: 1px solid #25263b; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.02)'" onmouseout="this.style.background='transparent'">
          <td style="padding: 14px 18px; color: #e1e1e6; font-size: 0.95rem; font-family: monospace;">${sub.email}</td>
          <td style="padding: 14px 18px; color: #a0a1b5; font-size: 0.9rem;">${date}</td>
          <td style="padding: 14px 18px; text-align: right;">
            <button class="btn-vimo btn-vimo-secondary btn-vimo-sm" type="button" 
              data-delete-subscriber="${sub.id}"
              style="padding: 4px 8px; border-color: rgba(255,91,91,0.2); color: #ff5b5b; font-size: 0.8rem; background: transparent; cursor: pointer; border-radius: 4px; transition: all 0.2s;"
              onmouseover="this.style.background='rgba(255,91,91,0.1)';" 
              onmouseout="this.style.background='transparent';">
              <i class="bi bi-trash"></i> Eliminar
            </button>
          </td>
        </tr>
      `;
    }).join('');
  }

  // Buscador
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase().trim();
      const filtered = allSubscribers.filter(sub => sub.email.toLowerCase().includes(query));
      renderTable(filtered);
    });
  }

  // Eliminar suscriptor
  on(document, 'click', '[data-delete-subscriber]', async (e, btn) => {
    const id = btn.getAttribute('data-delete-subscriber');
    if (!id) return;
    
    if (!confirm('¿Estás seguro de que deseas eliminar este suscriptor?')) return;
    
    try {
      btn.disabled = true;
      btn.textContent = 'Eliminando...';
      
      await apiRequest(`/newsletter/subscribers/${id}`, {
        method: 'DELETE'
      });
      
      toast({ message: 'Suscriptor eliminado correctamente.', type: 'success' });
      loadSubscribers();
    } catch (err) {
      console.error('[Admin] Error eliminando suscriptor:', err);
      toast({ message: err.message || 'Error al eliminar el suscriptor.', type: 'error' });
      btn.disabled = false;
      btn.innerHTML = '<i class="bi bi-trash"></i> Eliminar';
    }
  });

  loadSubscribers();
}

// ── ADMINISTRACIÓN DE SUSCRIPCIONES DE PAGO ────────────────────
async function initSuscripcionesAdmin() {
  console.log('[Admin] Inicializando panel de Suscripciones...');

  let allUsers = [];

  const usersTableBody = qs('#usersTableBody');
  const usersSearchInput = qs('#adminUsersSearchInput');

  // Cargar datos
  async function loadUsers() {
    try {
      if (usersTableBody) usersTableBody.innerHTML = '<tr><td colspan="5" style="padding: 24px; text-align: center; color: #8e90a6;">Cargando usuarios y suscripciones...</td></tr>';
      
      const users = await apiRequest('/subscriptions/admin/list');
      allUsers = users || [];
      
      renderUsersTable(allUsers);
    } catch (err) {
      console.error('[Admin] Error cargando usuarios:', err);
      toast({ message: err.message || 'Error al cargar los usuarios y suscripciones.', type: 'error' });
      if (usersTableBody) {
        usersTableBody.innerHTML = '<tr><td colspan="5" style="padding: 24px; text-align: center; color: #ff5b5b;">No se pudieron cargar las suscripciones de pago.</td></tr>';
      }
    }
  }

  // Renderizar tabla
  function renderUsersTable(list) {
    if (!usersTableBody) return;

    if (list.length === 0) {
      usersTableBody.innerHTML = '<tr><td colspan="6" style="padding: 24px; text-align: center; color: #8e90a6;">No se encontraron usuarios.</td></tr>';
      return;
    }

    usersTableBody.innerHTML = list.map(user => {
      const regDate = new Date(user.createdAt).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });

      const latestSub = user.subscriptions && user.subscriptions[0];
      let subBadge = '<span style="color: #8e90a6; font-size: 0.85rem; padding: 2px 6px; background: rgba(142, 144, 166, 0.1); border-radius: 4px;">Ninguna</span>';
      if (latestSub) {
        if (latestSub.status === 'active') {
          subBadge = '<span style="color: #10b981; font-size: 0.85rem; padding: 2px 6px; background: rgba(16, 185, 129, 0.1); border-radius: 4px; font-weight: bold;"><i class="bi bi-check-circle"></i> Aprobado</span>';
        } else if (latestSub.status === 'incomplete') {
          subBadge = '<span style="color: #f59e0b; font-size: 0.85rem; padding: 2px 6px; background: rgba(245, 158, 11, 0.1); border-radius: 4px;"><i class="bi bi-exclamation-triangle"></i> Incompleto</span>';
        } else if (latestSub.status === 'canceled') {
          subBadge = '<span style="color: #ff5b5b; font-size: 0.85rem; padding: 2px 6px; background: rgba(255, 91, 91, 0.1); border-radius: 4px;"><i class="bi bi-x-circle"></i> Cancelado</span>';
        }
      }

      // Región Badge
      const isBr = user.region === 'BR';
      const regionBadge = isBr
        ? '<span style="color: #6366f1; font-size: 0.85rem; padding: 2px 6px; background: rgba(99, 102, 241, 0.1); border-radius: 4px; font-weight: bold;">🇧🇷 Brasil</span>'
        : '<span style="color: #ec4899; font-size: 0.85rem; padding: 2px 6px; background: rgba(236, 72, 153, 0.1); border-radius: 4px; font-weight: bold;">🇪🇸 Latam/España</span>';

      // Plan/Estado Badge
      const isSubscribed = user.plan === 'suscrito' || user.plan === 'active' || (latestSub && latestSub.status === 'active');
      const planBadge = isSubscribed
        ? '<span style="color: #10b981; font-size: 0.85rem; padding: 2px 6px; background: rgba(16, 185, 129, 0.1); border-radius: 4px; font-weight: bold;"><i class="bi bi-star-fill"></i> Suscrito</span>'
        : '<span style="color: #f59e0b; font-size: 0.85rem; padding: 2px 6px; background: rgba(245, 158, 11, 0.1); border-radius: 4px; font-weight: bold;"><i class="bi bi-clock"></i> Trial</span>';

      // Precio Suscripción
      const priceText = isBr ? '$19,90 USD/mes' : '$29,90 USD/mes';
      const priceColor = isBr ? '#a5b4fc' : '#f9a8d4';
      const priceBadge = `<span style="color: ${priceColor}; font-size: 0.9rem; font-weight: bold;">${priceText}</span>`;

      return `
        <tr style="border-bottom: 1px solid #25263b; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.02)'" onmouseout="this.style.background='transparent'">
          <td style="padding: 14px 18px;">
            <div style="font-weight: 600; color: #fff;">${user.name || user.email.split('@')[0]}</div>
            <div style="font-size: 0.8rem; color: #8e90a6; font-family: monospace; margin-top: 2px;">${user.email}</div>
          </td>
          <td style="padding: 14px 18px;">${regionBadge}</td>
          <td style="padding: 14px 18px;">${planBadge}</td>
          <td style="padding: 14px 18px;">${priceBadge}</td>
          <td style="padding: 14px 18px;">${subBadge}</td>
          <td style="padding: 14px 18px; color: #a0a1b5; font-size: 0.9rem;">${regDate}</td>
        </tr>
      `;
    }).join('');
  }

  // Buscador
  if (usersSearchInput) {
    usersSearchInput.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase().trim();
      const filtered = allUsers.filter(user => 
        user.email.toLowerCase().includes(query) || 
        (user.name && user.name.toLowerCase().includes(query)) ||
        user.plan.toLowerCase().includes(query) ||
        (user.region && user.region.toLowerCase().includes(query))
      );
      renderUsersTable(filtered);
    });
  }

  loadUsers();
}
